import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinner, NgxSpinnerService } from 'ngx-spinner';
import { AppointmentService } from 'src/app/services/appointment.service';

@Component({
  selector: 'app-admin-view-student-observation',
  templateUrl: './admin-view-student-observation.component.html',
  styleUrls: ['./admin-view-student-observation.component.scss']
})
export class AdminViewStudentObservationComponent implements OnInit {

  show: boolean = false
  apptId: any
  observationForm: any
  studentObservation: any
  studentObservationTest: any
  apptDetails: any
  documents: any=[];
  appBaseUrl = environment.appBaseUrl;
  constructor(private activatedRoute: ActivatedRoute, private spinner: NgxSpinnerService, private appointmentService: AppointmentService) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.apptId = params['id']
    });
    this.show = false
    this.spinner.show();

    this.appointmentService.getAppointments(null, null, null, this.apptId,null,null).subscribe(res => {
      this.apptDetails = res.data[0]

      if (this.apptDetails.appointmentDetails.schedules[0].status == "ASSESMENT" || this.apptDetails.appointmentDetails.schedules[0].status == "COMPLETE")
        this.appointmentService.getObservationForm(this.apptId).subscribe(res => {
          this.observationForm = res.data
          this.studentObservation = res.data.studentObservation
          this.studentObservationTest = res.data.studentObservationTest


          this.appointmentService.getDocument(this.apptId).subscribe(res => {
            res.data.forEach((doc: any) => {
              this.documents.push(doc)
            });
            this.show = true;
            this.spinner.hide()

          })

        })
      else {
      this.show = true;
      this.spinner.hide()
      }
      
    })

  }

}
